var _desc, _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "https://www.w3.org/2000/svg",
    xmlnsXlink: "https://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_12058"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Facebook",
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Facebook",
    width: 16,
    height: 16,
    fill: "currentColor",
    fillOpacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_12058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 0C12.41 0 16 3.58 16 8C16 12.41 12.41 16 8 16C3.58 16 0 12.41 0 8C0 3.58 3.58 0 8 0Z",
    fill: "currentColor",
    fillOpacity: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.04 15.93L9.04 9.75L10.78 9.75L11.01 7.57L9.04 7.57L9.04 6.48C9.04 5.92 9.09 5.61 9.91 5.61L11 5.61L11 3.44L9.25 3.44C7.16 3.44 6.42 4.49 6.42 6.27L6.42 7.57L5.12 7.57L5.12 9.75L6.42 9.75L6.42 15.84C6.93 15.94 7.46 16 8 16C8.34 16 8.69 15.97 9.04 15.93Z",
    fill: "#1B6392",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.c439e96c4b9d10493e9f9c350326a514.svg";
export { ForwardRef as ReactComponent };